module.exports = __webpack_public_path__ + "media/images/iconPaginateLast__inactive-cff832a1dcb61e7bbef4a5fbd3300f4e.png";